<template>
  <section :id="'step-section-' + step.id">
    <v-layout row wrap>
        <div class="mr-5">
              <v-card
                flat
                class="ml-3 scroll-container"
                :class="{ 'constrain-w ml-5': $vuetify.breakpoint.mdAndUp}"
              >
                <affix
                  class="sidebar-menu"
                  relative-element-selector=".affix-target"
                  :enabled="($vuetify.breakpoint.mdAndUp) ? true : false"
                  :offset="affixOffset"
                  :key="'affix-key-' + step.id"
                >
                  <scrollactive
                    active-class="scroll-active"
                    :offset="145"
                    :duration="800"
                    bezier-easing-value=".5,0,.35,1"
                    :modify-url="false"
                    :highlight-first-item="true"
                  >
                    <v-navigation-drawer
                      floating
                      :value="true"
                      stateless
                    >

                      <v-list>
                        <v-list-tile class="header-menu-item py-3">
                          <v-list-tile-avatar
                            color="white"
                            class="black--text font-weight-bold"
                          >
                            {{ stepIndex + 1}}
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title
                              class="font-weight-bold white--text h4">
                              {{ step.name }}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <template
                          v-for="(item, index) in step.step_items"
                        >
                          <a
                            :href="'#menu-' + step.id + '-' + item.id"
                            class="menu-link d-block scrollactive-item black--text font-weight-bold"
                            :key="'item-link' + item.id"
                          >
                            <v-list-tile
                              :item="item"
                              class="menu-item"
                            >
                              <v-list-tile-content>
                                <v-list-tile-title class="menu-title">
                                  <div class="d-flex space-between align-center">
                                    <span class="step-title font-weight-bold">{{item.name}}</span>
                                    <v-icon class="icon-right" color="black" >fa-chevron-right</v-icon>
                                  </div>
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </a>
                            <v-divider :key="'divide-' + index"  class="menu-divider mx-2"></v-divider>
                        </template>

                      </v-list>

                    </v-navigation-drawer>
                  </scrollactive>
                </affix>
              </v-card>

            </div>

            <v-flex xs12 sm6 class="justify-center scroll-view" :class="{ 'mx-0 px-1 my-3': $vuetify.breakpoint.smAndDown, 'mx-3 px-2' : $vuetify.breakpoint.mdAndUp}">
              <div>
                <!-- <p v-if="step.step_type.id == 2" class="py-0 px-3 mb-5">
                    Text will go here on earning the micro credential and how these will be scored. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Integer posuere erat a ante venenatis dapibus posuere velit aliquet.
                </p> -->
                <v-card
                 flat
                 v-for="(item) in step.step_items"
                 :key="'step-content-' + item.id"
                 :item="item"
                 :id="'menu-' + step.id + '-' + item.id"
                 class="step-item-content mt-3"
                >
                  <h3 class="header-step-title px-3 pb-2">{{ item.name }}</h3>
                  <hr class="thick mx-3" />
                  <template v-if="typeof item.content != 'string'">
                    <v-card flat class="pl-0 step-item-card" v-for="block in item.content" :key="block.formId"
                    v-show="(block.beforeContent || block.afterContent) || (block.type !== 'hidden' && block.type !== 'script')">

                      <v-card-text v-html="block.beforeContent" v-if="block.beforeContent"></v-card-text>

                      <div v-if="block.type === 'script'">
                          <script type="application/javascript">
                            {{ block.content }}
                          </script>
                      </div>

                      <div v-if="block.type === 'style'" v-show="false">
                        <script type="application/javascript">
                          var style = document.createElement('style');
                          style.type = 'text/css';
                          style.innerHTML = "{{ block.content }}";
                          document.getElementsByTagName('head')[0].appendChild(style);
                        </script>
                      </div>

                      <v-container class="px-3 py-0 w-50" v-if="block.type === 'textinput'">
                        <label v-if="block.label">
                          <strong v-html="block.label"></strong><strong>:</strong>
                          <strong><span v-if="block.required && !item.completed" class="required">*</span></strong>
                        </label>
                        <v-text-field
                          v-model="formModel[tabModel][block.formId]"
                          v-if="block.type === 'textinput' && !item.completed"
                          :id="block.formId"
                          :required="block.required"
                          :name="block.formName"
                          class="mx-1"
                          type="text"
                          :placeholder="block.placeholder"
                          :readonly="item.completed"
                          flat
                        /></v-text-field>

                        <span
                          class="mx-1"
                          :id="block.formId"
                          v-if="block.type === 'textinput' && item.completed"
                        >{{ formModel[tabModel][block.formId] }}</span>
                      </v-container>

                      <div v-if="block.type === 'textarea'">
                        <v-container class="px-3 pt-0 pb-2">
                          <v-textarea
                            v-model="formModel[tabModel][block.formId]"
                            class="module-textarea"
                            auto-grow
                            flat
                            outline
                            :id="block.formId"
                            :name="block.formName"
                            placeholder="Enter your response..."
                            v-on="!item.completed  ? { change: backgroundTextSave } : {}"
                            :readonly="item.completed"
                            hide-details
                          >
                          </v-textarea>
                        </v-container>
                      </div>

                      <v-textarea
                        v-if="block.type === 'hidden'" v-show="false"
                        v-model="formModel[tabModel][block.formId]"
                        class="module-hidden"
                        :id="block.formId"
                        :name="block.formName"
                        v-on="!item.completed  ? { change: backgroundTextSave } : {}"
                        :readonly="item.completed"
                        hide-details
                      > {{ block.content }}
                      </v-textarea>

                      <div v-if="block.type === 'file' && !module.completed">
                        <v-container class="px-3 py-0">
                          <amaze-upload
                            @dropzone-mounted="dropzoneMounted"
                            @new-userfile-id="backgroundDropzoneSave"
                            @dropzone-removed="backgroundDropzoneSave"
                            :dropzone-id="block.formId"
                            :dropzone-ref="block.formId"
                            :dropzone-max-files="20"
                            :destroy-dropzone="false"
                          >
                          </amaze-upload>
                        </v-container>
                      </div>

                      <div class="px-3" v-if="block.type === 'file' && module.completed">
                        <v-container class="module-completed-file-wrapper ">
                        <div v-if="downloading"></div>
                          <v-layout row wrap align-center justify-start>
                            <v-flex v-for="(file, fileIndex) in formModel[tabModel][block.formId]" :key="'comp-file-' + fileIndex" class="pa-1" :class="{ 'file-card': isFileType(file) }" xs12>
                              <v-card flat tile class="completed-card">
                                <v-card-text v-if="file.downloading" class="file-name">
                                  <span>{{ file.name}}</span>
                                  <v-progress-circular v-if="file.downloading" :indeterminate="true"></v-progress-circular>
                                </v-card-text>
                                <a v-else @click.prevent="downloadFile(file)" target="_blank" rel="noopener" class="file-link">
                                  <v-card-text class="file-name"> {{file.name}}</v-card-text>
                                </a>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </div>

                      <div v-if="block.type === 'pdfviewer'" class="px-3 pdf-container">
                        <iframe width="100%" height="600" :src="block.url | getFileEmbedURL" frameborder="0"></iframe>
                      </div>

                      <div v-if="block.type === 'youtube'" class="px-3 pdf-container">
                        <youtube :video-id="block.url | youtubeId"></youtube>
                      </div>

                      <v-card-text v-html="block.afterContent" v-if="block.afterContent"></v-card-text>
                    </v-card>

                    <!-- <v-container v-if="step.step_type_id===2" class="shrink ml-4 elevation-1" style="width: 320px;">
                      <v-layout align-center justify-start>
                        <v-flex class="shrink mr-3">
                            <v-icon size="38px" color="secondary">fas fa-clipboard-check</v-icon>
                        </v-flex>
                        <v-flex>
                          <v-layout column>
                            <v-flex class="shrink"><h4>Assessment Rubric</h4></v-flex>
                            <v-flex>
                              <router-link to="/module/1">View the criteria for the scoring ></router-link>
                              {{item.rubric_level }}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container> -->

                  </template>
                  <template v-else>
                    <v-card flat class="step-item-card">
                      <v-card-text v-html="item.content"></v-card-text>
                    </v-card>
                  </template>
                </v-card>
              </div>
              <slot></slot>
              <v-flex v-if="isLastStep && !module.completed" id="submitContainers" class="mt-4 align-self-center submit-container">
                    <hr>
                    <v-layout row align-center>
                      <v-flex>
                       <v-btn
                         large
                         @click="submitModuleForm({background: false})"
                         class="my-4 mx-5 px-5 py-2 primary"
                         id="completeModuleButton"
                       >
                       Submit
                       </v-btn>
                    </v-flex>
                    <v-flex>
                        <p class="my-4 mx-5 py-2" id="submissionHelp">Not ready to submit? All work will be automatically saved so you can return and complete at a later date.</p>
                    </v-flex>
                   </v-layout>
                   <hr>
                </v-flex>
            </v-flex>
    </v-layout>
  </section>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.form-flex {
  display: flex;
}

.scroll-container {
  position: relative;
  &.constrain-w {
     min-width: 250px;
  }
  .v-navigation-drawer {
    background-color: $amaze-yellow;

    .header-menu-item {
      background-color: $amaze-yellow-dark;
      white-space: normal;
      height: auto;
      .v-avatar {
        font-weight: 500;
        font-size: 20px;
        color: #000 !important;
      }
      .v-list__tile__title {
        white-space: normal;
        height: auto;
        overflow: visible;
      }
    }
    .menu-link.scroll-active {
      background-color: #fff;
      margin: 5px;
    }
    hr.menu-divider {
      border: 0.033em dashed #fff;
    }
  }
}
.menu-title {
  white-space: normal;
  height: auto;
}
.icon-right {
  display: flex;
  justify-content: flex-end;
  opacity: 0;
  .scroll-active & {
    opacity: 1;
  }
}
::v-deep .step-item-content {

  .dese-table-header{
    background-color: #274C93;
    color:white;
    text-align: center !important;
    font-weight: bold;
  }
  .step-item-card {
    hr {
      border: 0.0325em solid #000;
      width: 100px;
      margin-bottom: 20px;
    }
    .module-completed-file-wrapper {
      background-color: $light-gray;
      border-radius: 2px;

      .completed-card {
        border: 3px solid #ccc;
        border-radius: 2px;
      }
      .completed-card {
        height: 80px;
        .file-name {
          height: 100%;
          line-height: 40px;
          span {
            margin-right: 20px;
          }
        }
        .file-name,
        .file-link {
          color: black;
        }
        &:hover {
          .file-name {
            background-color: rgba(0,0,0,0.3);
            opacity: 1;
            color: #fff;
            height: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .file-link {
            opacity: 1;
          }
        }
      }
      .file-card {
        .completed-card {
          &:before {
            // content: "\f15b"; /* file icon */
            // content: "\f1ce"; /* file icon */
            font-family: 'Font Awesome\ 5 Free';
            // left: 41%;
            position: absolute;
            display: flex;
            // top: 18%;
            font-size: 40px;
            color: darken(#ccc, 10);
          }
        }
      }
    }
  }
  .module-textarea {
   ::v-deep &.v-textarea.v-text-field--enclosed {
      .v-input__slot {
        padding: 0;
        .v-text-field__slot {
          margin-right: 0;
          textarea {
            margin: 0 !important;
            padding: 15px;
            &[readonly] {
              background-color: $light-gray;
            }
          }
        }
      }
    }
    &.v-text-field--outline.theme--light {
      .v-input__slot:focus,
      .v-input__slot:hover {
        border-color: $icon-blue !important;
      }

      &.v-input--is-readonly {
        .v-input__slot:focus,
        .v-input__slot:hover {
          border-color: $light-gray !important;
        }
      }
    }
  }
}
</style>

<script>
import { Affix } from 'vue-affix'
import { YouTubePlayer, getIdFromURL } from 'vue-youtube-embed'
import TrainingModuleService from "@/services/TrainingModuleService"
import { EventBus } from "@/components/Events/event-bus";

/**
 * This is a global function to give us the ability to set
 * input values programatically outside of the context of
 * Vue. This is a concession we're making for the purpose
 * of supporting highly customized functionality for the
 * peer review process requested in the beta phase of
 * this project.
 */
window.AmazeModuleSetTextAreaValue = function(taId, taVal) {
  let el = document.getElementById(taId);
  if (el) {
    try {
      el.value = taVal;
      el.dispatchEvent(new Event('input'));
      el.dispatchEvent(new Event("change"));
      window.AmazeModuleStepItemBackgroundSave();
    } catch (e) {
      console.log(e);
    }
  }
}

export default {
  props: {
    module: Object,
    step: Object,
    stepIndex: Number,
    formModel: Object,
    tabModel: String,
    dropzones: Array,
    isLastStep: Boolean
  },
  components: {
    Affix,
    Youtube: YouTubePlayer
  },
  data() {
    return {
      instanceStepModel: this.tabModel,
      downloading: 0
    }
  },
  computed: {
    shouldConfirmSubmission() {
      if (typeof this.module.config.config.StepItem.confirmSubmission !== "undefined") {
        return this.module.config.config.StepItem.confirmSubmission;
      } else {
        return true;
      }
    },
    submissionConfirmationText() {
      return 'Are you sure you want to submit your evaluation?';
    },
    affixOffset() {
      return (this.$vuetify.breakpoint.mdAndUp) ? { top: 30, bottom: 80 } : { top: -30, bottom: 80 }
    }
  },
  watch: {
    tabModel: function() {
      if (this.step.step_type.id === 2) {
        // update our responses whenever props change
        this.populateFormResponses()
      }
    },
    module: function() {
      if (this.step.step_type.id === 2) {
        // update our responses whenever props change
        this.populateFormResponses()
      }
    },
    step: {
      handler: function(newStep) {
        if (newStep.step_type.id === 2) {
          // update our responses whenever props change
          this.populateFormResponses()
        }
      },
      deep: true
    }
  },
  methods: {
    confirmSubmission() {
      if (this.shouldConfirmSubmission) {
        return confirm(this.submissionConfirmationText);
      } else {
        return true;
      }
    },
    validateForm: function () {
      for (var model in this.formModel[this.tabModel]) {
        var elem = document.getElementById(model);
        var req = elem && elem.attributes && elem.attributes.required;
        if (!this.formModel[this.tabModel][model] && req) {
          return false;
        }
      }

      return true;
    },
    submitModuleForm(data = {}) {
      if (this.module.completed) {
        return false;
      }

      if (!this.validateForm()) {
        this.$store.commit('updateMessage', {
          message: 'Please fill out all required information before submitting.',
          snackbar: true
        })
        return false;
      }

      if ((data.background && this.tabModel === this.instanceStepModel) || (data.background === false && this.confirmSubmission())) {
        const formData = {
          ...this.formModel[this.tabModel],
          moduleId: this.step.module_id,
          stepId: this.step.id,
          completed: !data.background
        };
        TrainingModuleService.submitModuleForm(formData)
          .then(
            () => {
              this.$store.commit('updateMessage', {
                message: 'Form Submitted Successfully!',
                snackbar: !data.background
              })

              if (!data.background) {
                EventBus.$emit('refresh-module'); this.$store.commit("updateModules");
                this.$nextTick(() => {
                  // Add the component back in
                  this.$router.push({ path: '/dashboard' });
                });
              }
            },
            () => {
              console.log("[trainingModule] submitModuleForm error");
            }
          );
      }
    },
    populateFormResponses() {
      // only populates evaluation type steps
      this.step.step_items.forEach((stepItem) => {
        if (typeof stepItem.content !== 'string') {
          stepItem.content.forEach((item) => {
            if (typeof item.responses === 'undefined') {
              // reset form field
              this.formModel[this.tabModel][item.formId] = '';
            } else if (item.responses.length) {
              if (item.type === 'textarea' || item.type === 'hidden' || item.type === 'textinput') {
                this.formModel[this.tabModel][item.formId] = (item.responses[0].content) ? this.makeText(item.responses[0].content) : ''
              } else if (item.type === 'file') {
                item.responses.forEach((fileRes) => {
                  if (!this.module.completed) {
                    const dz = this.dropzones.find(dz => dz.$refs[fileRes['form_attr']])
                    // set a flag so our remove-file dropzone listener doesn't trigger
                    dz.$refs[fileRes['form_attr']].manualCleanup = true;
                    // clean out the dropzone each time so there is no stale files in there
                    dz.$refs[fileRes['form_attr']].removeAllFiles(true)
                    // reset the flag
                    dz.$refs[fileRes['form_attr']].manualCleanup = false;
                  }
                  const formFiles = fileRes.userfiles.map((fileItem) => {
                    const dz = this.dropzones.find(dz => dz.$refs[fileRes['form_attr']])
                    const file = {
                      id: fileItem.id,
                      formId: item.formId,
                      name: fileItem.name,
                      size: fileItem.filesize, // keep
                      filesize: fileItem.filesize, // both
                      type: fileItem.mime,
                      url: fileItem.full_url
                    }
                    if (!this.module.completed) {
                      const alreadyAdded = dz.$refs[item.formId].dropzone.files.some((item) => {
                        return (item.name === file.name && item.size === file.filesize)
                      });
                      if (!alreadyAdded) {
                        dz.$refs[item.formId].manuallyAddFile(file, fileItem.full_url)
                      }
                    }
                    return file;
                  })
                  this.$set(this.formModel[this.tabModel], fileRes['form_attr'], formFiles)
                })
              }
            }
          })
        }
      })
    },
    backgroundTextSave() {
      this.submitModuleForm({ background: true, formStep: this.tabModel });
    },
    backgroundDropzoneSave(dropzone) {
      if (dropzone.dzid && typeof dropzone.dzid !== 'undefined') {
        // process newly added files
        if (typeof this.formModel[this.tabModel][dropzone.dzid] !== 'undefined' && this.formModel[this.tabModel][dropzone.dzid].length) {
          // append file to model file array
          this.formModel[this.tabModel][dropzone.dzid].push(dropzone.data)
        } else {
          // first file added
          this.$set(this.formModel[this.tabModel], dropzone.dzid, [dropzone.data]);
        }
        this.submitModuleForm({ background: true, formStep: this.tabModel });
      } else if (!dropzone.$refs[dropzone.dropzoneId].manualCleanup) {
        // process a removed file
        // dzFiles will contain only the files that currently exist in the dropzone
        // we'll filter the model files and identify which one need to be removed from dz
        const dzFiles = dropzone.$refs[dropzone.dropzoneId].dropzone.files;
        const modelFiles = this.formModel[this.tabModel][dropzone.dropzoneId].filter((mf) => {
          return dzFiles.find((df) => {
            return (mf.name === df.name && mf.filesize === df.size);
          })
        });
        this.$set(this.formModel[this.tabModel], dropzone.dropzoneId, modelFiles);
        this.submitModuleForm({ background: true, formStep: this.tabModel });
      }
    },
    dropzoneMounted(dropzoneVue) {
      this.dropzones.push(dropzoneVue);
    },
    makeText(html) {
      // fix for htmlentites not converting to text
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent;
    },
    isFileType(file) {
      // For now we want to show a file icon, no thumbnail.
      return true;

      // Previously we showed things differently, so if we want that back, then use this...
      // return !file.type.startsWith('image');
    },
    downloadFile(file) {
      this.downloading++;
      file.downloading = true;
      this.$http
        .get(file.url, { responseType: "arraybuffer" })
        .then(response => {
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.setAttribute("download", file.name);
          tempLink.href = window.URL.createObjectURL(new Blob([response.data]));
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          this.downloading--;
          file.downloading = false;
        });
    }
  },
  filters: {
    youtubeId(url) {
      return getIdFromURL(url);
    },
    getFileEmbedURL(url) {
      const encodedUrl = encodeURIComponent(url)
      return `https://docs.google.com/viewerng/viewer?url=${encodedUrl}&hl=en&embedded=true`
    }
  },
  mounted() {
    if (this.step.step_type.id === 2) {
      this.populateFormResponses();
    }

    // Some magic sauce for hidden fields.
    this.step.step_items.forEach((stepItem) => {
      if (typeof stepItem.content !== 'string') {
        stepItem.content.forEach((item) => {
          if (item.type === 'hidden' && item.content) {
            this.formModel[this.tabModel][item.formId] = item.content;
          }
        });
      }
    });

    // Opening up the background save process to global (window) scope so that
    // we can use it in scrpting logic of step items. This is to help support
    // peer review, since now we can automate the value of hidden fields and
    // then trigger a save (and by extension a notification).
    window.AmazeModuleStepItemBackgroundSave = () => {
      this.backgroundTextSave();
    };
  },
  destroyed() {
    EventBus.$off('setup-module');
  }
}
</script>
